

/**
 * Adjusts the brightness and of a color.
 * @param {string} hex - The hexadecimal color code.
 * @param {number} factor - The factor by which to adjust the brightness.
 * @returns {string} - The new color in hexadecimal format.
 */
export function getShades(hex: string, factor: number = 10): string {
  console.warn(hex)
  const hexToRgb = (hex: string) => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  };

  const rgbToHex = (r: number, g: number, b: number) => {
    const toHex = (c: number) => {
      const hex = c.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  const adjustBrightness = (r: number, g: number, b: number, factor: number) => {
    return {
      r: Math.min(255, Math.max(0, r + factor)),
      g: Math.min(255, Math.max(0, g + factor)),
      b: Math.min(255, Math.max(0, b + factor)),
    };
  };

  const { r, g, b } = hexToRgb(hex);
  const adjustedColor = adjustBrightness(r, g, b, factor);
  return rgbToHex(adjustedColor.r, adjustedColor.g, adjustedColor.b);
}

export enum COLORS {
  RED = '#CB253D',
  BLUE = '#145DAD',
  GREEN = '#2CA046',
  YELLOW = '#FFAF8D',
  ROSE = '#FF8A8A',
  DARK_BLUE = '#0E427C',
  LIGHT_BLUE = '#CAE2FC',
  ORANGE = '#FAA31E',
  BABY_RED = '#E97183',
  BABY_YELLOW = '#F5E65F',
  BABY_GREEN = '#B6F088',
  BABY_BLUE = '#9FF6F1',
  STEEL_BLUE = '#388B9D',
  DARK_GREEN = '#1A652B',
  BABY_ORANGE = '#FFD6B0',
  MINT_GREEN = '#B8FCEB',
  CONFIRM_GREEN = '#B8FCCA',
  BABY_PURPLE = '#B39DDB',
}

export enum SIZES {
  XSMALL = '40px',
  SMALL = '50px',
  MEDIUM = '62px',
  LARGE = '72px',
  FILL = '100%',
}
